import http from '@/uteis/http'

export default class VirtusRepositoryService {
  async dowloadGuiTramite (guia) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/files/guia', { params: { guia }, responseType: 'blob' }).then((response) => {
        return resolve(response)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/files/guia', { params: { guia }, responseType: 'blob' }).then((response) => {
          return resolve(response)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async dowloadEtiqueta (numeroProcesso, volume) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/files/etiqueta', { params: { numeroProcesso, volume }, responseType: 'blob' }).then((response) => {
        return resolve(response)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/files/etiqueta', { params: { numeroProcesso, volume }, responseType: 'blob' }).then((response) => {
          return resolve(response)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
